import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 121.51 179.09' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <path
          className='cls-1'
          d='M121.51 179.09H0V0h121.51zM8 171.09h105.51V8H8z'
        />
        <path
          className='cls-1'
          d='M60.76 73.33a24.59 24.59 0 1 1 24.58-24.59 24.62 24.62 0 0 1-24.58 24.59zm0-44.18a19.59 19.59 0 1 0 19.58 19.59 19.61 19.61 0 0 0-19.58-19.59z'
        />
        <path
          className='cls-1'
          d='M60.76 63.33a14.59 14.59 0 1 1 14.58-14.59 14.61 14.61 0 0 1-14.58 14.59zm0-24.18a9.59 9.59 0 1 0 9.59 9.59 9.6 9.6 0 0 0-9.59-9.59zM60.76 144.94a24.59 24.59 0 1 1 24.59-24.59 24.62 24.62 0 0 1-24.59 24.59zm0-44.18a19.59 19.59 0 1 0 19.59 19.59 19.61 19.61 0 0 0-19.59-19.59z'
        />
        <path
          className='cls-1'
          d='M60.76 154.94a34.59 34.59 0 1 1 34.59-34.59 34.63 34.63 0 0 1-34.59 34.59zm0-64.18a29.59 29.59 0 1 0 29.59 29.59 29.62 29.62 0 0 0-29.59-29.59z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/AudioIcon.js